/**
 * GxNotes: the one footnote block under a table or chart: one muted block, each sentence once (a repeated sentence is dropped here, so two callers
 * that both say "Provisional until the finale" show it a single time). Basis, definitions and "near" explanations all live here, not in stacked captions.
 */
import type { ReactNode } from "react";
import "./system.css";

export function GxNotes({ notes, testId }: { readonly notes: readonly (string | ReactNode | null | undefined | false)[]; readonly testId?: string }) {
  const seen = new Set<string>();
  const kept = notes.filter((n): n is string | ReactNode => n !== null && n !== undefined && n !== false && n !== "").filter((n) => {
    if (typeof n !== "string") return true;
    const key = n.trim().toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  if (kept.length === 0) return null;
  return <div className="gx-notes" data-testid={testId}>{kept.map((n, i) => <p key={typeof n === "string" ? n : i}>{n}</p>)}</div>;
}
